import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-web-awesome',
	templateUrl:'./WebAwesomePluginPage.html',
	styles: [],
	styleUrls:['./WebAwesomePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WebAwesomePluginPage
{
	mdContent_129 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>web-awesome</artifactId>
</dependency>
\`\`\``;
	mdContent_130 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:web-awesome:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_131 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Outlined);

var tabs = new WaTabs<>();
var tab1 = new WaTab<>("Overview");
var panel1 = new WaTabPanel<>();
panel1.add(new WaText<>().setText("Tab content here"));
tabs.add(tab1);
tabs.add(panel1);
\`\`\``;
	mdContent_132 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Outlined);

var button = new WaButton<>("Click Me", Variant.Brand);
button.setAppearance(Appearance.Filled);

var stack = new WaStack();
stack.setGap(PageSize.Medium);
stack.add(card);
stack.add(button);
\`\`\``;
}
